import { IUserWithAnagraphicGroup } from '../interfaces/userWithAnagraphicGroup';
import { IShadowUserCreate } from '../interfaces/shadowUserCreate';
import { ShadowUserCreate } from './shadowUserCreate';
import { IUserWithGroup } from '../interfaces/userWithGroup';
import { UserWithGroup } from './userWithGroup';
import { IUserWithAnagraphic } from '../interfaces/userWithAnagraphic';

export class UserWithAnagraphicGroup implements IUserWithAnagraphicGroup {
    public anagraphicUser: IShadowUserCreate;
    public user: IUserWithGroup;

    constructor() {
        this.anagraphicUser = new ShadowUserCreate();
        this.user = new UserWithGroup();
    }

    static fromUserWithAnagraphic(
        userWithAnagraphic: IUserWithAnagraphic
    ): UserWithAnagraphicGroup {
        //todo: refactoring
        const newInstance = new UserWithAnagraphicGroup();
        newInstance.anagraphicUser.lastName = userWithAnagraphic.anagraphicUser.lastName;
        newInstance.anagraphicUser.firstName = userWithAnagraphic.anagraphicUser.firstName;
        newInstance.anagraphicUser.email = userWithAnagraphic.anagraphicUser.email;
        newInstance.anagraphicUser.postalCode = userWithAnagraphic.anagraphicUser.postalCode;
        newInstance.anagraphicUser.numberAddress = userWithAnagraphic.anagraphicUser.numberAddress;
        newInstance.anagraphicUser.note = userWithAnagraphic.anagraphicUser.note;
        newInstance.anagraphicUser.mobilePhoneNumber =
            userWithAnagraphic.anagraphicUser.mobilePhoneNumber;
        newInstance.anagraphicUser.id = userWithAnagraphic.anagraphicUser.id;
        newInstance.anagraphicUser.fiscalCode = userWithAnagraphic.anagraphicUser.fiscalCode;
        newInstance.anagraphicUser.faxNumber = userWithAnagraphic.anagraphicUser.faxNumber;
        newInstance.anagraphicUser.exponentAddress =
            userWithAnagraphic.anagraphicUser.exponentAddress;
        newInstance.anagraphicUser.city = userWithAnagraphic.anagraphicUser.city;
        newInstance.anagraphicUser.address = userWithAnagraphic.anagraphicUser.address;
        newInstance.anagraphicUser.anagraphicType =
            userWithAnagraphic.anagraphicUser.anagraphicType;
        newInstance.anagraphicUser.phoneNumber = userWithAnagraphic.anagraphicUser.phoneNumber;
        newInstance.anagraphicUser.province = userWithAnagraphic.anagraphicUser.province;
        newInstance.anagraphicUser.shortProvince = userWithAnagraphic.anagraphicUser.shortProvince;
        //User information
        newInstance.user.username = userWithAnagraphic.user.username;
        newInstance.user.email = userWithAnagraphic.user.email;
        newInstance.user.firstName = userWithAnagraphic.anagraphicUser.firstName;
        newInstance.user.lastName = userWithAnagraphic.anagraphicUser.lastName;
        newInstance.user.id = userWithAnagraphic.user.id;
        newInstance.user.teleselling = userWithAnagraphic.user.teleselling;
        if (userWithAnagraphic.groups && userWithAnagraphic.groups.length) {
            newInstance.user.idGroup =
                userWithAnagraphic.user.rUsersGroupsIdGroupNavigation[0].idGroup;
        }
        if (userWithAnagraphic.user.rUsersRoles && userWithAnagraphic.user.rUsersRoles.length) {
            newInstance.user.idRole = userWithAnagraphic.user.rUsersRoles[0].idRole;
        }
        newInstance.user.isDisabled = userWithAnagraphic.user.isDisabled;
        newInstance.user.permissionContractsType = userWithAnagraphic.permitContracts;
        newInstance.user.optionalContractAttaches = userWithAnagraphic.optionalAttachments;
        newInstance.user.canExportContract = userWithAnagraphic.user.canExportContract;
        newInstance.user.canDoExportSemplice = userWithAnagraphic.user.canDoExportSemplice;
        newInstance.user.canDoExportGas = userWithAnagraphic.user.canDoExportGas;
        newInstance.user.canDoExportEe = userWithAnagraphic.user.canDoExportEe;
        newInstance.user.permitBrands = userWithAnagraphic.permitBrands;
        newInstance.user.customerVisibility = userWithAnagraphic.user.customerVisibility;
        newInstance.user.canStopContracts = userWithAnagraphic.user.canStopContracts;
        newInstance.user.contractDelayTolerance = userWithAnagraphic.user.contractDelayTolerance;
        newInstance.user.canMoveCustomers = userWithAnagraphic.user.canMoveCustomers;
        newInstance.user.needVerificationCall = userWithAnagraphic.user.needVerificationCall;
        newInstance.user.canDoAdesioneADistanza = userWithAnagraphic.user.canDoAdesioneADistanza;
        newInstance.user.canHandleStopForErrors = userWithAnagraphic.user.canHandleStopForErrors;
        newInstance.user.canDoChiamataBenvenuto = userWithAnagraphic.user.canDoChiamataBenvenuto;
        newInstance.user.canDoPortaUnAmico = userWithAnagraphic.user.canDoPortaUnAmico;
        return newInstance;
    }
}



// WEBPACK FOOTER //
// ./src/app/models/request-and-responses/rest-api/classes/userWithAnagraphicGroup.ts